<template>
	<div class="no-data">
		<div class="content">
			<img src="../../assets/img/no_data.png" alt="" />
			<p>{{ title }}</p>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			default: '没有符合条件的邮件'
		}
	}
}
</script>

<style lang="scss" scoped>
.no-data {
	padding-top: 120px;
	position: relative;
	.content {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		img {
			width: 125px;
			height: 125px;
		}
		p {
			font-size: 14px;
			color: #666666;
			line-height: 21px;
		}
	}
}
</style>
